import React, {useState} from "react";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    AccordionSummaryProps,
    Grid,
    SvgIcon,
    Tooltip,
    Typography
} from "@mui/material";
import {ExpandMore as ExpandMoreIcon} from "@mui/icons-material";
import InfoIcon from "./icons/InfoIcon";
import Instruction from "./components/Instruction";
import {styled} from "@mui/material/styles";
import ArrowOutIcon from "./icons/ArrowOutIcon";
import {Simulate} from "react-dom/test-utils";
import ArrowInIcon from "./icons/ArrowInIcon";

const CustomAccordionSummary = styled((props: AccordionSummaryProps) => (
    <AccordionSummary
        expandIcon={<ExpandMoreIcon/>}
        {...props}
    />
))(({ theme }) => ({
    // backgroundColor:
    //     theme.palette.mode === 'dark'
    //         ? 'rgba(255, 255, 255, .05)'
    //         : 'rgba(0, 0, 0, .03)',
    // flexDirection: 'row-reverse',
    '& .MuiAccordionSummary-content': {
        maxWidth: '100%',
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1)

    },
    '& .MuiAccordionSummary-root': {
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
    },
    '& .MuiAccordionSummary-content.Mui-expanded': {
        marginBottom: "8px",
        marginTop: "8px"
    },
}));

const SystemPrompt: React.FC<SystemPromptProps> = (props) => {
    const {generationParamsVisible, currentSystemPrompt, updateCurrentSystemPrompt, isGenerating} = props;
    const systemPromptChatRef = React.useRef<HTMLDivElement>(null);
    const [showTextExpandedView, setShowTextExpandedView] = useState(false);

    const toggleExpandedView = () => {
        setShowTextExpandedView(showTextExpandedView => !showTextExpandedView);
    }

    return <Grid item xs={12} md={12}>
        <Accordion
            ref={systemPromptChatRef}
            style={{
                boxShadow: '0px 0px 0px 0px #0F1A2A14',
                border: 'solid #E2E8F0',
                borderWidth: '0px 0px 1px 0px',
                width: '100%',
                padding: 0
            }}>
            <CustomAccordionSummary
                expandIcon={<ExpandMoreIcon/>}
                style={{width: `${generationParamsVisible ? "100%" : "calc(100% - 220px)"}`, minHeight: "48px"}}>
                <Typography variant={"body2"}
                            style={{fontWeight: 600}}
                            sx={{
                                minWidth: 140,
                                maxWidth: 140,
                                width: '20%',
                                marginTop: '2px',
                                display: "flex",
                                alignItems: "center"
                            }}>System Prompt

                    <Tooltip disableFocusListener title="Give instructions to guide the model's behavior. For example, you can ask the model to assume roles like sales agent, coach, or support agent. You can also set rules that the model should follow during the chat.">
                        <SvgIcon style={{marginLeft: 4}}>
                            <InfoIcon/>
                        </SvgIcon>
                    </Tooltip>
                </Typography>
                <Typography
                    sx={{color: 'text.secondary',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                    }}>{!!currentSystemPrompt ? currentSystemPrompt : "Enter prompt here"}</Typography>
            </CustomAccordionSummary>
            <AccordionDetails style={{padding: 0, margin: "0 14px 4px 14px", position: "relative"}}>
                <Instruction instruction={currentSystemPrompt}
                             instructionSubmitted={() => {
                             }}
                             disableIcon={true}
                             disabled={false}
                             minRows={showTextExpandedView ? 3 : 10}
                             maxRows={showTextExpandedView ? 3 : 10}
                             placeholderText={"You are a sales coaching assistant. You..."}
                             setInstruction={updateCurrentSystemPrompt}
                             isGenerating={isGenerating}/>

                    <SvgIcon style={{position: 'absolute', right: 0, bottom: 0, cursor: 'pointer'}} onClick={toggleExpandedView}>
                    {
                        showTextExpandedView ? <ArrowOutIcon /> : <ArrowInIcon/>
                    }
                    </SvgIcon>
            </AccordionDetails>
        </Accordion>
    </Grid>
}

interface SystemPromptProps {
    generationParamsVisible: boolean,
    currentSystemPrompt: string,
    updateCurrentSystemPrompt: (currentSystemPrompt: string) => void,
    isGenerating: boolean
}

export default SystemPrompt;